import React, { useState, useEffect } from 'react';
import EventLabel from '../../../components/EventLabel/EventLabel';
import { Transition } from '@headlessui/react';

interface SnackbarProps {
  message: string;
  showSnackbar: boolean;
  setShowSnackbar: React.Dispatch<React.SetStateAction<boolean>>;
}

const Snackbar: React.FC<SnackbarProps> = ({ message, showSnackbar, setShowSnackbar }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (showSnackbar) {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
        setShowSnackbar(false);
      }, 3000);
    }
  }, [showSnackbar, setShowSnackbar]);

  return (
    <Transition show={isVisible} as={React.Fragment}>
      <Transition.Child
        enter="transition-opacity ease-linear duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div
          className={`${
            isVisible ? 'bottom-1' : '-bottom-20'
          } z-20 fixed left-2  flex gap-x-3 items-center w-fit rounded-md bg-green-600 text-white font-normal p-4 transition-transform duration-300 transform`}
        >
          <i className="ri-check-line bg-white text-green-900 rounded-full p-1"></i> <EventLabel name={message} groupName="CMS.Hotel" />
        </div>
      </Transition.Child>
    </Transition>
  );
};

export default Snackbar;
